import { FilterModel } from '@ag-grid-community/core/dist/esm/es6/interfaces/iFilter';
import { IServerSideGetRowsParams } from '@ag-grid-community/core/dist/esm/es6/interfaces/iServerSideDatasource';
import { formatDate } from '@angular/common';
import { Injectable } from '@angular/core';
import { Apollo, ApolloBase, gql } from 'apollo-angular';
import { map, Observable } from 'rxjs';
import { GridService } from '../interfaces/grid-service';

@Injectable({
    providedIn: 'root',
})
export class NotificationsGridService implements GridService {
    NAME = 'NotificationsGridService';
    private apollo: ApolloBase;
    constructor(private apolloProvider: Apollo) {
        this.apollo = this.apolloProvider.use('usersAPI');
    }

    public getRows(params: IServerSideGetRowsParams<any, any>, pageNumber: number, pageSize: number): Observable<any> {
        const notificationStatuses = (params.request.filterModel as FilterModel)['status']?.values;
        const getUserNotifications = `
                    query getUserNotifications (
                        $orderDirection: OrderDirection,
                        $orderBy: String,
                        $startDateTime: DateOnly,
                        $completedDateTime: DateOnly,
                        $operationName: String
                    ) {
                        userNotifications {
                            getUserNotifications(
                                searchSettings: {
                                    pageNumber: ${pageNumber},
                                    pageSize: ${pageSize},
                                    orderDirection: $orderDirection,
                                    orderBy: $orderBy
                                },
                                filtering: {
                                    startDateTime: $startDateTime
                                    completedDateTime: $completedDateTime
                                    operationName: $operationName
                                     ${notificationStatuses ? 'notificationStatuses: [' + notificationStatuses + ']' : ''},
                                }
                            )  {
                                data {
                                    id
                                    isRead
                                    notificationType
                                    operationName
                                    startDateTime
                                    completedDateTime
                                    notes
                                    status
                                    downloadLink,
                                    userNotificationMetadataItems {
                                        key
                                        value
                                    }
                                },
                                totalCount
                            }
                        }
                    }
                `;

        return this.apollo
            .query({
                query: gql(getUserNotifications),
                variables: {
                    orderBy: params.request.sortModel[0]?.colId ?? 'startDateTime',
                    orderDirection: params.request.sortModel[0]?.sort.toUpperCase() ?? 'DESC',
                    operationName: (params.request.filterModel as FilterModel)['operationName']?.filter,
                    startDateTime: (params.request.filterModel as FilterModel)['startDateTime']?.filter
                        ? formatDate((params.request.filterModel as FilterModel)['startDateTime']?.filter, 'yyyy-MM-dd', 'en-US')
                        : undefined,
                    completedDateTime: (params.request.filterModel as FilterModel)['completedDateTime']?.filter
                        ? formatDate((params.request.filterModel as FilterModel)['completedDateTime']?.filter, 'yyyy-MM-dd', 'en-US')
                        : undefined,
                },
                fetchPolicy: 'no-cache',
            })
            .pipe(
                map((response: any) => {
                    return response.data.userNotifications.getUserNotifications;
                }),
            );
    }
}
